import { render, staticRenderFns } from "./RolesForm.vue?vue&type=template&id=5c6c07fb&scoped=true"
import script from "./RolesForm.vue?vue&type=script&lang=js"
export * from "./RolesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6c07fb",
  null
  
)

export default component.exports